/**
 * API客户端核心类型定义
 * L1网络通信层的基础类型
 */
/**
 * API错误类
 */
export class ApiError extends Error {
    constructor(message, code, status, data) {
        super(message);
        this.code = code;
        this.status = status;
        this.data = data;
        this.name = 'ApiError';
    }
}
//# sourceMappingURL=types.js.map